import React from "react"

import { ProductPositionMultiSelectSidebar } from "./ProductPositionMultiSelectSidebar"
import {
  UseProductPositionMultiSelectSidebarModelArgs,
  useProductPositionMultiSelectSidebarModel
} from "./hooks/useProductPositionMultiSelectSidebarModel"

export const ProductPositionMultiSelectSidebarConnector = React.memo(
  (props: UseProductPositionMultiSelectSidebarModelArgs) => (
    <ProductPositionMultiSelectSidebar
      {...useProductPositionMultiSelectSidebarModel(props)}
    />
  )
)
